"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiPropertyOptional = exports.ApiProperty = void 0;
const noopDecorator = () => {
    return () => {
        // Browser-only no-op replacement for Nest Swagger decorators.
    };
};
exports.ApiProperty = noopDecorator;
exports.ApiPropertyOptional = noopDecorator;
